/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Rule_Sets_Create_ItalicInputs */

const en_forms_rule_sets_create_italic = /** @type {(inputs: Forms_Rule_Sets_Create_ItalicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Italic`)
};

const de_forms_rule_sets_create_italic = /** @type {(inputs: Forms_Rule_Sets_Create_ItalicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kursiv`)
};

/**
* | output |
* | --- |
* | "Italic" |
*
* @param {Forms_Rule_Sets_Create_ItalicInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const forms_rule_sets_create_italic = /** @type {((inputs?: Forms_Rule_Sets_Create_ItalicInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Rule_Sets_Create_ItalicInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forms_rule_sets_create_italic(inputs)
	return de_forms_rule_sets_create_italic(inputs)
});